import { rest } from 'msw';

import { courseDetailReportMock } from '../reports.mock';
import { LMS_BACK_URL } from 'config/variables';
import { getEnvironments } from 'store/useAtomOutsideComponent';

const getCourseDetailReport = rest.get(
  `${LMS_BACK_URL}report/course-detail/:clientId/:courseId`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        data: courseDetailReportMock,
        status: 'success',
      }),
    );
  },
);

export const reportsHandlers = [getCourseDetailReport];
